import type { SegmentMeta } from "../shared/types";

type EncoderInputMessage =
  | {
      type: "add-segment";
      index: number;
      text: string;
      buffer: ArrayBuffer;
    }
  | {
      type: "finalize";
      totalSegments: number;
    };

type EncoderOutputMessage =
  | {
      type: "completed";
      buffer: ArrayBuffer;
      meta: SegmentMeta[];
    }
  | {
      type: "error";
      message: string;
    };

export class AudioEncoderClient {
  private worker: Worker;

  constructor() {
    this.worker = new Worker(new URL("./workers/audio-encoder.worker.ts", import.meta.url), {
      type: "module",
    });
  }

  addSegment(index: number, text: string, buffer: ArrayBuffer): void {
    const message: EncoderInputMessage = {
      type: "add-segment",
      index,
      text,
      buffer,
    };
    this.worker.postMessage(message, [buffer]);
  }

  finalize(totalSegments: number): Promise<{ mp3Buffer: ArrayBuffer; meta: SegmentMeta[] }> {
    return new Promise((resolve, reject) => {
      const handleMessage = (event: MessageEvent<EncoderOutputMessage>) => {
        const payload = event.data;

        if (payload.type === "completed") {
          this.worker.removeEventListener("message", handleMessage);
          resolve({ mp3Buffer: payload.buffer, meta: payload.meta });
          return;
        }

        if (payload.type === "error") {
          this.worker.removeEventListener("message", handleMessage);
          reject(new Error(payload.message));
        }
      };

      this.worker.addEventListener("message", handleMessage);
      const finalizeMessage: EncoderInputMessage = {
        type: "finalize",
        totalSegments,
      };
      this.worker.postMessage(finalizeMessage);
    });
  }

  terminate(): void {
    this.worker.terminate();
  }
}
